import { Link } from "react-router-dom";
import { ArrowLeft, Home } from "lucide-react";

export default function TermsConditions() {
  return (
    <div className="min-h-screen bg-[#020617] text-white">
      {/* Header */}
      <nav className="bg-[#0f172a] border-b border-slate-800 px-4 md:px-8 py-4">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-amber-500 rounded-lg flex items-center justify-center">
              <Home className="w-4 h-4 text-white" />
            </div>
            <span className="font-bold">Thames Mortgage & Protection</span>
          </Link>
          <Link to="/" className="flex items-center gap-2 text-slate-400 hover:text-white text-sm">
            <ArrowLeft className="w-4 h-4" /> Back to Home
          </Link>
        </div>
      </nav>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 md:px-8 py-12">
        <h1 className="text-3xl font-bold mb-8">Terms & Conditions</h1>
        
        <div className="prose prose-invert prose-slate max-w-none space-y-6 text-slate-300">
          <p>
            These terms and conditions apply as between you, the User of Services provided therein and 
            Thames Mortgage & Protection Ltd, the owner(s) of the Services and this Website. Your agreement 
            to comply with and be bound by these terms and conditions is deemed to occur upon your acceptance 
            of these terms and conditions prior to your first use of the Services.
          </p>

          <h2 className="text-xl font-semibold text-white mt-8">Definitions</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>"Account"</strong> means the personal information and access credentials used by Users to access the Services through the Website.</li>
            <li><strong>"Agreement"</strong> means the binding agreement between the User and Thames Mortgage & Protection Ltd following acceptance of these terms.</li>
            <li><strong>"Content"</strong> means any text, graphics, images, audio, video, software, data compilations and any other form of information on the Website.</li>
            <li><strong>"Services"</strong> means the online facilities, tools, services, or information that Thames Mortgage & Protection Ltd makes available through the Website.</li>
            <li><strong>"User"</strong> means any third party that accesses the Website and Services not employed by Thames Mortgage & Protection Ltd.</li>
            <li><strong>"Website"</strong> means www.thamesresi.com and any sub-domains unless expressly excluded.</li>
          </ul>

          <h2 className="text-xl font-semibold text-white mt-8">Provision of Services</h2>
          <p>
            Thames Mortgage & Protection Ltd shall use its best and reasonable endeavours to provide the Services 
            on an error-free basis and without interruption. Thames Mortgage & Protection Ltd shall have the right, 
            exercisable at its sole discretion, to terminate provision of the Services without prior notice to Users.
          </p>

          <h2 className="text-xl font-semibold text-white mt-8">Access to Services</h2>
          <p>
            The User represents and warrants that they have the authority to enter into the Agreement, to use the 
            Services, and to perform all acts as may be necessary under these terms and conditions. To use the 
            Services, Users are required to create an Account and submit certain personal details.
          </p>
          <p>By accepting these terms, the User represents and warrants that:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Any information submitted is accurate and truthful</li>
            <li>All such information will be kept accurate and up to date</li>
            <li>How they identify themselves does not violate any part of these terms or applicable laws</li>
          </ul>

          <h2 className="text-xl font-semibold text-white mt-8">Use of Services</h2>
          <p>Users are permitted to use the Services only in accordance with:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>These terms and conditions</li>
            <li>Any relevant law, regulation, or other applicable instrument</li>
          </ul>
          <p>Users may not:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Attempt to download, convert or reverse-engineer any part of the Services</li>
            <li>Engage in conduct that may disrupt provision of the Services</li>
            <li>Reproduce, copy, duplicate, trade or resell the Services without express agreement</li>
          </ul>

          <h2 className="text-xl font-semibold text-white mt-8">Intellectual Property</h2>
          <p>
            All Content included on the Website, unless submitted by Users, including text, graphics, logos, icons, 
            images, sound clips, video clips, data compilations, page layout, underlying code and software is the 
            property of Thames Mortgage & Protection Ltd, our affiliates or other relevant third parties.
          </p>

          <h2 className="text-xl font-semibold text-white mt-8">User Content</h2>
          <p>When using the Services to create Content, Users must not:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Submit Content that is unlawful, abusive, threatening, harassing, defamatory or fraudulent</li>
            <li>Submit Content intended to promote or incite violence</li>
            <li>Submit Content containing viruses or damaging software</li>
            <li>Impersonate other people, particularly employees of Thames Mortgage & Protection Ltd</li>
            <li>Use the Services for unauthorised mass-communication such as spam</li>
          </ul>

          <h2 className="text-xl font-semibold text-white mt-8">Disclaimer of Warranties</h2>
          <p>
            Thames Mortgage & Protection Ltd makes no warranty or representation that the Website or Services will 
            meet Users' requirements, that they will be of satisfactory quality, fit for a particular purpose, 
            not infringe rights of third parties, be compatible with all systems, or be secure.
          </p>
          <p className="text-amber-500 font-medium mt-4">
            No part of the Website or Services is intended to constitute advice and the Content should not be 
            relied upon when making any decisions or taking any action of any kind.
          </p>

          <h2 className="text-xl font-semibold text-white mt-8">Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, Thames Mortgage & Protection Ltd accepts no liability for any 
            direct or indirect loss or damage, foreseeable or otherwise, including any indirect, consequential, 
            special, or exemplary damages arising from the use of the Website or Services.
          </p>

          <h2 className="text-xl font-semibold text-white mt-8">Termination</h2>
          <p>
            Thames Mortgage & Protection Ltd reserves the right to terminate the Agreement, a User's Account, and 
            access to the Services at any time for material breach, non-compliance, legal requirements, or if it 
            becomes no longer commercially viable to continue providing the Services.
          </p>

          <h2 className="text-xl font-semibold text-white mt-8">Law and Jurisdiction</h2>
          <p>
            These terms and conditions and all aspects of the relationship between the User and Thames Mortgage & 
            Protection Ltd shall be governed by and construed in accordance with the Laws of England and Wales.
          </p>

          <h2 className="text-xl font-semibold text-white mt-8">Contact</h2>
          <p>
            All notices and communications shall be sent to Thames Mortgage & Protection Ltd by post to 
            Unit 4.1, Town Quay Wharf, Abbey Road, Barking, IG11 7BZ or by email to admin@thamesresi.com.
          </p>
        </div>
      </div>

      {/* Footer */}
      <footer className="border-t border-slate-800 py-8 px-4 md:px-8">
        <div className="max-w-4xl mx-auto text-center text-slate-500 text-sm">
          <p>© 2026 Thames Mortgage & Protection Ltd. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
